exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#reordericon {\r\n  display: flex;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  margin-left: auto;\r\n  margin-right: auto;\n}\n.k-grid.dragging tbody tr:hover td.below,\r\n.k-grid.dragging tbody tr:hover td.below ~ td {\r\n  border-bottom-color: #0094fb;\n}\n.k-grid.dragging tbody tr:hover td.above,\r\n.k-grid.dragging tbody tr:hover td.above ~ td {\r\n  border-top-color: #0094fb;\n}\n.disabled-row {\r\n  background-color: #f5f5f5 !important;\r\n  color: #a0a0a0 !important;\r\n  pointer-events: none !important;\r\n  opacity: 0.6;\r\n  user-select: none;\n}\r\n", ""]);

// exports
